<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tiskalniki C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Tiskalniki C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sl" title="Varnostne informacije">
     Varnostne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvencije">
      Konvencije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Izjave o izdelku">
      Izjave o izdelku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_sl" title="Seznanitev s tiskalnikom">
     Seznanitev s tiskalnikom
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sl" title="Iskanje informacij o tiskalniku">
      Iskanje informacij o tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sl" title="Iskanje serijske &scaron;tevilke tiskalnika">
      Iskanje serijske &scaron;tevilke tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sl" title="Konfiguracije tiskalnika">
      Konfiguracije tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sl" title="Uporaba nadzorne plo&scaron;če">
      Uporaba nadzorne plo&scaron;če
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sl" title="Prilagajanje začetnega zaslona">
      Prilagajanje začetnega zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sl" title="Razumevanje stanja indikatorja">
      Razumevanje stanja indikatorja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e627" title="Izbiranje papirja">
      Izbiranje papirja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_sl" title="Nastavitev, namestitev in konfiguracija">
     Nastavitev, namestitev in konfiguracija
    </a>
   </p>
   <div id="divd0e1351">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sl" title="Izbiranje mesta za tiskalnik">
      Izbiranje mesta za tiskalnik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sl" title="Priključitev kablov">
      Priključitev kablov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_sl" title="Namestitev dodatnih pladnjev">
      Namestitev dodatnih pladnjev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1549" title="Nastavitev in uporaba programov na začetnem zaslonu">
      Nastavitev in uporaba programov na začetnem zaslonu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1676" title="Nalaganje papirja in posebnih tiskalnih medijev">
      Nalaganje papirja in posebnih tiskalnih medijev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1851" title="Name&scaron;čanje in posodabljanje programske opreme, gonilnikov in vdelane programske opreme">
      Name&scaron;čanje in posodabljanje programske opreme, gonilnikov in vdelane programske opreme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2110" title="Omrežje">
      Omrežje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_sl" title="Tiskanje strani z menijskimi nastavitvami">
      Tiskanje strani z menijskimi nastavitvami
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_sl" title="Za&scaron;čita tiskalnika">
     Za&scaron;čita tiskalnika
    </a>
   </p>
   <div id="divd0e2555">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sl" title="Brisanje pomnilnika tiskalnika">
      Brisanje pomnilnika tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sl" title="Obnovitev privzetih tovarni&scaron;kih nastavitev">
      Obnovitev privzetih tovarni&scaron;kih nastavitev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sl" title="Izjava o obstojnosti">
      Izjava o obstojnosti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_sl" title="Tiskanje">
     Tiskanje
    </a>
   </p>
   <div id="divd0e2677">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sl" title="Tiskanje iz računalnika">
      Tiskanje iz računalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2703" title="Tiskanje iz mobilne naprave">
      Tiskanje iz mobilne naprave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sl" title="Konfiguracija zaupnih opravil">
      Konfiguracija zaupnih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sl" title="Tiskanje zaupnih in drugih zadržanih opravil">
      Tiskanje zaupnih in drugih zadržanih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sl" title="Tiskanje iz profila na platformi Cloud Connector">
      Tiskanje iz profila na platformi Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_sl" title="Tiskanje seznama vzorcev pisav">
      Tiskanje seznama vzorcev pisav
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_sl" title="Postavitev ločevalnih listov med kopije">
      Postavitev ločevalnih listov med kopije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sl" title="Preklic tiskalnega opravila">
      Preklic tiskalnega opravila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sl" title="Nastavitev temnosti tonerja">
      Nastavitev temnosti tonerja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sl" title="Uporaba menijev tiskalnika">
     Uporaba menijev tiskalnika
    </a>
   </p>
   <div id="divd0e3245">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_sl" title="Zemljevid menijev">
      Zemljevid menijev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3502" title="Naprava">
      Naprava
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4994" title="Tiskanje">
      Tiskanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5942" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6182" title="Omrežje/vrata">
      Omrežje/vrata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8172" title="Varnost">
      Varnost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_sl" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8828" title="Poročila">
      Poročila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sl" title="Odpravljanje težav">
      Odpravljanje težav
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sl" title="Vzdrževanje tiskalnika">
     Vzdrževanje tiskalnika
    </a>
   </p>
   <div id="divd0e9031">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_sl" title="Preverjanje stanja delov in potreb&scaron;čin">
      Preverjanje stanja delov in potreb&scaron;čin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sl" title="Konfiguracija obvestil o stanju potro&scaron;nega materiala">
      Konfiguracija obvestil o stanju potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sl" title="Nastavitev e-po&scaron;tnih opozoril">
      Nastavitev e-po&scaron;tnih opozoril
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_sl" title="Ogled poročil">
      Ogled poročil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sl" title="Naročanje delov in potro&scaron;nega materiala">
      Naročanje delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9850" title="Zamenjava delov in potro&scaron;nega materiala">
      Zamenjava delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10048" title="Či&scaron;čenje delov tiskalnika">
      Či&scaron;čenje delov tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10169" title="Varčevanje z energijo in papirjem">
      Varčevanje z energijo in papirjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sl" title="Premikanje tiskalnika na drugo mesto">
      Premikanje tiskalnika na drugo mesto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_sl" title="Po&scaron;iljanje tiskalnika">
      Po&scaron;iljanje tiskalnika
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_sl" title="Odpravljanje težav">
     Odpravljanje težav
    </a>
   </p>
   <div id="divd0e10330">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_sl" title="Težave s kakovostjo tiskanja">
      Težave s kakovostjo tiskanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10430" title="Težave pri tiskanju">
      Težave pri tiskanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sl" title="Tiskalnik se ne odziva">
      Tiskalnik se ne odziva
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12835" title="Težave z omrežno povezavo">
      Težave z omrežno povezavo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13054" title="Težave s potro&scaron;nim materialom">
      Težave s potro&scaron;nim materialom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sl" title="Odpravljanje zastojev">
      Odpravljanje zastojev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13491" title="Težave pri podajanju papirja">
      Težave pri podajanju papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13873" title="Težave s kakovostjo barv">
      Težave s kakovostjo barv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sl" title="Vzpostavitev stika s podporo strankam">
      Vzpostavitev stika s podporo strankam
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sl" title="Recikliranje in odlaganje">
     Recikliranje in odlaganje
    </a>
   </p>
   <div id="divd0e14112">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sl" title="Recikliranje Lexmarkovih izdelkov">
      Recikliranje Lexmarkovih izdelkov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sl" title="Recikliranje embalaže izdelkov Lexmark">
      Recikliranje embalaže izdelkov Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sl" title="Obvestila">
     Obvestila
    </a>
   </p>
   <div id="divd0e14147">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14150" title="Informacije o izdelku">
      Informacije o izdelku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14167" title="Obvestilo o izdaji">
      Obvestilo o izdaji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sl" title="Blagovne znamke">
      Blagovne znamke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sl" title="Obvestila o licenciranju">
      Obvestila o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sl" title="Zvočne emisije">
      Zvočne emisije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sl" title="Direktiva o odpadni električni in elektronski opremi (OEEO)">
      Direktiva o odpadni električni in elektronski opremi (OEEO)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14264" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sl" title="Odlaganje izdelka">
      Odlaganje izdelka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14298" title="Litij-ionska baterija za polnjenje">
      Litij-ionska baterija za polnjenje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sl" title="Uredba (EU) 2023/1542">
      Uredba (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sl" title="Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje">
      Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sl" title="Obvestilo o občutljivosti na statično elektriko">
      Obvestilo o občutljivosti na statično elektriko
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sl" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sl" title="Obvestilo o laserskem tiskalniku">
      Obvestilo o laserskem tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sl" title="Poraba energije">
      Poraba energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14549" title="Regulativna obvestila za brezžične izdelke">
      Regulativna obvestila za brezžične izdelke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sl" title="Obvestilo o modularnih komponentah">
      Obvestilo o modularnih komponentah
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sl" title="Izpostavljenost radiofrekvenčnemu sevanju">
      Izpostavljenost radiofrekvenčnemu sevanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14575" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_sl" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue